import React from 'react'
import { InvoiceListProvider } from './Context'
import { Layout } from './Layout'
import { Breadcrumb, Page, PageHeader } from '@ztechapps/webui.page'
import { routesDef } from '../../../config/routes'
import { invoicePermissions } from '@ztechapps/totalmilk-payme.common'

const items = [routesDef.OverviewPage, routesDef.InvoicesPage]

export const InvoiceListPage = (props) => {
  return (
    <InvoiceListProvider {...props}>
      <Page roleName={invoicePermissions.canView.value}>
        <PageHeader breadcrumbs={<Breadcrumb items={items} />} />
        <Layout />
      </Page>
    </InvoiceListProvider>
  )
}
